
// branchs
export const GET_BRANCHES = "/branches";
export const ADD_NEW_BRANCH = "/branches";
export const UPDATE_BRANCH = "/branches";
export const DELETE_BRANCH = "/branches";


